import React, { useEffect, useState } from 'react'
import ExternalLayout from '../../layout/External'
import LogoNevula from '../../assets/images/logo-nevula.svg'
import Form from '../../components/Form'
import { useForm } from 'react-hook-form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import Button from '../../components/General/Button'
import { useHistory, useLocation } from 'react-router'
import { AuthService } from '../../services/AuthService'

let authService = new AuthService()
const ForgotPassword: React.FC<any> = () => {
  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const form = useForm()

  const { addAlert } = useSnackBars()

  const location = useLocation()

  const history = useHistory()

  const submit = async (values) => {
    let instance = new URLSearchParams(location.search)

    let code = instance.get('code')

    let username = instance.get('username')

    if (values.password !== values.password2) {
      addAlert({
        message: 'Las contraseñas deben de coincidir',
        status: 'error',
      })
      return
    }

    if (/^(?=.{6,}$)((?=.*[a-z])(?=.*\d).+)$/.test(values.password)) {
      try {
        addAlert({
          message: 'Cargando',
          status: 'loading',
        })
        await authService.forgotPasswordSubmit(username, code, values.password)
        // addAlert({
        //   message: 'Contraseña cambiada satisfactoriamente',
        //   status: 'success',
        // })

        let keys = Object.keys(localStorage)
        console.log('keys...')
        keys.forEach((key) => {
          if (/^CognitoIdentityServiceProvider/.test(key)) {
            localStorage.removeItem(key)
          }
        })
        localStorage.removeItem('credentials')

        history.push('/ingresar?passwordChanged=true')
      } catch (err) {
        addAlert({
          message: 'Error al modificar la clave',
          status: 'error',
        })
      }
    } else {
      addAlert({
        message: 'Contraseña inválida',
        status: 'error',
      })
    }
  }

  return (
    <div className="w-full flex justify-center items-center h-screen">
      <div
        className={`shadow-md bg-white dark:bg-black rounded-2xl px-10 py-12 mb-4 w-1/3 ${
          windowSize.innerWidth < 700
            ? 'w-11/12'
            : windowSize.innerWidth < 1300
            ? 'w-1/3'
            : 'w-1/3'
        }`}
      >
        <div className="w-full">
          <h1 className="font-bold text-3xl text-coolGray-900 mb-2 dark:text-white text-center">
            Recuperación de contraseña
          </h1>

          <Form form={form} onSubmit={submit}>
            <FormItem classes="col-span-12 my-2" name="password">
              <InputText label="Contraseña" isUpperValue={false} password />
            </FormItem>

            <FormItem classes="col-span-12 my-2" name="password2">
              <InputText
                label="Confirmar contraseña"
                isUpperValue={false}
                password
              />
            </FormItem>

            <div className="col-span-12">
              <Button
                type="primary"
                classes="mt-6 font-semibold tracking-wide w-full"
                htmlType="submit"
              >
                Continuar
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
